
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
props: {
keyWord: String,
focus: Boolean
},
data() {
return {
inputKeyWord: this.keyWord,
activeStatus: false
};
},
watch: {
$route() {
this.inputKeyWord = this.keyWord;
},
inputKeyWord(val) {
this.$emit("update:keyWord", val);
}
},
components: {
Group,
XInput,
Icon
},
methods: {
handleSearch() {
this.$emit("handleSearch", this.inputKeyWord);
},
handleFocus() {
this.activeStatus = true;
this.$emit("handleFocus");
},
handleBlur() {
setTimeout(() => {
this.activeStatus = false;
}, 0);
}
},
mounted() {
if (this.focus) {
this.$refs.myInput.focus();
}
}
};
